<template>
  <el-card>
    <div slot="header" class="clearfix">
      <el-col :lg="8">
        <el-page-header @back="back" title :content="$t('pdv-relatorio')"></el-page-header>
      </el-col>
    </div>
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="9">
          <el-form-item :label="$t('data')" prop="range" class="is-required">
            <el-date-picker v-model="ruleForm.range" type="daterange" align="right" unlink-panels clearable
              range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"
              style="width: 70%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="9" v-if="showPdvFilter">
          <el-form-item :label="$t('pdv')" prop="customer" :class="{ 'is-required': userType === '1' }">
            <CustomerList v-model="ruleForm.customer" :customerType="1" :pdv="true" :multiple="false"
              class="customer-filter" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="6">
          <el-form-item label-width="0px">
            <el-button type="info" @click="fetchRecords()">Filtrar</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-collapse v-model="items">
      <el-collapse-item name="1">
        <template slot="title">
          Atendimentos&nbsp; <b-badge variant="primary">{{ total.call }}</b-badge>
        </template>

        <PdvCallListTable ref="tableCall" v-show="ruleForm.dashboard" :startedAt="ruleForm.range[0]"
          :finishedAt="ruleForm.range[1]" :customer="ruleForm.customer" @update="totals" />
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          Postagem&nbsp; <b-badge variant="primary">{{ total.post }}</b-badge>
        </template>
        <PdvCallListPrepost ref="tablePost" v-show="ruleForm.dashboard" :startedAt="ruleForm.range[0]"
          :finishedAt="ruleForm.range[1]" :customer="ruleForm.customer" @update="totals" />
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          Objetos Marketplace - Atendimentos: &nbsp; <b-badge variant="primary">{{ total.marketplace }}</b-badge>
        </template>

        <PdvMarketplaceObject ref="marketplaceObject" v-show="ruleForm.dashboard" :startedAt="ruleForm.range[0]"
          :finishedAt="ruleForm.range[1]" :customer="ruleForm.customer" @update="totals" />
      </el-collapse-item>
    </el-collapse>
    <br />
    <div class="row">
      <PdvUserPaymentDashboard ref="userPayment" v-show="ruleForm.dashboard" :startedAt="ruleForm.range[0]"
        :finishedAt="ruleForm.range[1]" :customer="ruleForm.customer" />
      <PdvUserDateDashboard ref="userMonth" v-show="ruleForm.dashboard" :startedAt="ruleForm.range[0]"
        :finishedAt="ruleForm.range[1]" :customer="ruleForm.customer" />
    </div>
    <div class="row">
      <PdvUserConferenceDashboard ref="userConference" v-show="ruleForm.dashboard" :startedAt="ruleForm.range[0]"
        :finishedAt="ruleForm.range[1]" :customer="ruleForm.customer" />
    </div>
  </el-card>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import { CustomerService } from "@/services/customers/customers.services";
import PdvUserPaymentDashboard from "./dashboard/PdvUserPaymentDashboard";
import PdvUserDateDashboard from "./dashboard/PdvUserDateDashboard";
import PdvCallListTable from "./dashboard/PdvCallListTable";
import PdvCallListPrepost from "./dashboard/PdvCallListPrepost";
import PdvUserConferenceDashboard from "./dashboard/PdvUserConferenceDashboard.vue";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import PdvMarketplaceObject from "./dashboard/PdvMarketplaceObject";
export default {
  name: "PdvReport",
  components: {
    CustomerList,
    PdvUserPaymentDashboard,
    PdvUserDateDashboard,
    PdvCallListTable,
    PdvCallListPrepost,
    PdvUserConferenceDashboard,
    PdvMarketplaceObject,
  },
  computed: {
    showPdvFilter() {
      const vm = this;
      if (vm.isPdvAttendant) return false;
      if (vm.userType === '1') return true;
      return vm.userType === '3' && vm.pdvCustomers.length > 1;
    },
  },
  methods: {
    back() {
      this.$router.replace({
        name: 'pdv',
      })
    },
    totals(type, total) {
      const vm = this;
      vm.total[type] = total;
    },
    fetchRecords() {
      const vm = this;
      if (vm.userType === '1' && !vm.isPdvAttendant && !vm.ruleForm.customer) {
        return this.$message({
          type: "error",
          message: "Você deve selecionar o cliente",
          offset: 45,
        });

      }
      vm.ruleForm.dashboard = true;
      vm.$refs.userPayment.fetch();
      vm.$refs.userMonth.fetch();
      vm.$refs.tableCall.fetch();
      vm.$refs.userConference.fetch();
      vm.$refs.tablePost.fetch();
      vm.$refs.marketplaceObject.fetch();
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((user) => {
        vm.userType = user.type;
        // Só a flag pdv define atendente: admin de licença pode ter customerPdv sem atender
        vm.isPdvAttendant = !!user.pdv;
        if (vm.userType === '3' && !vm.isPdvAttendant) {
          // PDVs (lojas) da licença que têm atendente, para decidir se o filtro aparece
          CustomerService.select(50, 1, 1, "", true)
            .then((response) => {
              vm.pdvCustomers = response.records || [];
            })
            .catch(() => {
              vm.pdvCustomers = [];
            });
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
          offset: 45,
        });
      });
  },
  data() {
    return {
      userType: '2',
      isPdvAttendant: false,
      pdvCustomers: [],
      items: '0',
      total: {
        call: 0,
        post: 0,
        marketplace: 0,
      },
      ruleForm: {
        range: [new Date(), new Date()],
        customer: '',
        dashboard: false,
      }
    }
  }
};
</script>

<style>
.btn-card {
  width: 180px;
  height: 100px;
}

.icon-large {
  height: 40px;
}

.customer-filter .el-select {
  width: 100%;
}
</style>